import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Headers from '../components/Headers'
import Banner from '../components/Banner'
import Categorys from '../components/Categorys'
import FeatureProducts from '../components/products/FeatureProducts'
import FeatureShops from '../components/shops/FeaturedShops'
import Products from '../components/products/Products'
import Footer from '../components/Footer'
import { Button } from "../components/ui/button"
import { get_category, get_products, fetchFeaturedSellers } from '../store/reducers/homeReducer'
import { Verified } from 'lucide-react'

const Home = () => {
    const dispatch = useDispatch()
    const {
        products,
        latest_product,
        topRated_product,
        discount_product,
        featuredSellers,
    } = useSelector(state => state.home)

    useEffect(() => {
        dispatch(fetchFeaturedSellers());
        dispatch(get_products());
    }, [dispatch]);
    
    console.log(featuredSellers);
    return (
        <div className='dark w-full'>
            <Headers />
            <Banner />
            <div className='my-4'>
                <Categorys />
            </div>
            <div className='py-[20px]'>
                <FeatureProducts products={products} />
            </div>
            <div className='py-[20px]'>
                <FeatureShops shops={featuredSellers} />
            </div>
            <div className='py-10'>
                <div className='w-[85%] flex flex-wrap mx-auto'>
                    <div className="grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-7">
                        <div className='overflow-hidden'>
                            <Products title='Latest Product' products={latest_product} />
                        </div>
                        <div className='overflow-hidden'>
                            <Products title='Top Rated Products' products={topRated_product} />
                        </div>
                        <div className='overflow-hidden'>
                            <Products title='On discount' products={discount_product} />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Home